import { render, staticRenderFns } from "./reform.vue?vue&type=template&id=0b602176&scoped=true&"
import script from "./reform.vue?vue&type=script&lang=js&"
export * from "./reform.vue?vue&type=script&lang=js&"
import style0 from "./reform.vue?vue&type=style&index=0&id=0b602176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b602176",
  null
  
)

export default component.exports